import { FETCH_SPOT_CONTACTS_BC_FAILURE, FETCH_SPOT_CONTACTS_BC_PSYCO_FAILURE, FETCH_SPOT_CONTACTS_BC_PSYCO_REQUEST, FETCH_SPOT_CONTACTS_BC_PSYCO_SUCCESS, FETCH_SPOT_CONTACTS_BC_REQUEST, FETCH_SPOT_CONTACTS_BC_SUCCESS, RESET_SPOT_CONTACT_BC } from "../../actions/targetedReachout/spotContactBattleCardActions";

  const initialState = {
    spotContactBCLoading: true,
    spotContactBCData: [],
    spotContactBCError: null,
  };

  const initialStateForPsyco={
    spotContactBCPsycoLoading: true,
    spotContactBCPsycoData: [],
    spotContactBCPsycoError: null,
  }
  
  export const spotContactBCReducer = (state = initialState, action) => {
    switch (action.type) {
      case FETCH_SPOT_CONTACTS_BC_REQUEST:
        return { ...state, spotContactBCLoading: true , payload: action.payload};
      case FETCH_SPOT_CONTACTS_BC_SUCCESS:
        return { ...state, spotContactBCLoading: false, spotContactBCData: action.payload };
      case FETCH_SPOT_CONTACTS_BC_FAILURE:
        return { ...state, spotContactBCLoading: false, spotContactBCError: action.payload };      
      case RESET_SPOT_CONTACT_BC:   
        return initialState;   
      default:
        return state;
    }
  };


  export const spotContactBCPsycoReducer = (state = initialStateForPsyco, action) => {
    switch (action.type) {
      case FETCH_SPOT_CONTACTS_BC_PSYCO_REQUEST:
        return { ...state, spotContactBCPsycoLoading: true , payload: action.payload};
      case FETCH_SPOT_CONTACTS_BC_PSYCO_SUCCESS:
        return { ...state, spotContactBCPsycoLoading: false, spotContactBCPsycoData: action.payload };
      case FETCH_SPOT_CONTACTS_BC_PSYCO_FAILURE:
        return { ...state, spotContactBCPsycoLoading: false, spotContactBCPsycoError: action.payload };  
      case RESET_SPOT_CONTACT_BC:   
        return initialStateForPsyco;                
      default:
        return state;
    }
  };
  

  


  
